import {faBold} from '@fortawesome/pro-solid-svg-icons'
import {faItalic, faStrikethrough, faSubscript, faSuperscript} from '@fortawesome/pro-regular-svg-icons'

import {FaIcon} from '@sdox/ui'

import {EditorFeature} from '../types'
import {useTipTapEditorContext} from '../EditorContext'
import {EditorControlButton} from './EditorControlButton'
import {ControlGroup} from './ControlGroup'

const features = [
  EditorFeature.bold,
  EditorFeature.italic,
  EditorFeature.strikethrough,
  EditorFeature.superscript,
  EditorFeature.subscript,
  EditorFeature.nobreak,
  EditorFeature.medium,
  EditorFeature.small,
]

export const MarkControls = () => {
  const {editor} = useTipTapEditorContext()

  return (
    <ControlGroup features={features}>
      <EditorControlButton
        active={editor.isActive('bold')}
        feature={EditorFeature.bold}
        onClick={() => editor.chain().focus().toggleBold().run()}
        title={'Bold'}
        trailing={<FaIcon icon={faBold} />}
      >
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('italic')}
        feature={EditorFeature.italic}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        title={'Italic'}
        trailing={<FaIcon icon={faItalic} />}
      >
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('strike')}
        feature={EditorFeature.strikethrough}
        onClick={() => editor.chain().focus().toggleStrike().run()}
        title={'Strike through'}
        trailing={<FaIcon icon={faStrikethrough} />}
      >
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('superscript')}
        feature={EditorFeature.superscript}
        onClick={() => editor.chain().focus().toggleSuperscript().run()}
        title={'Super script'}
        trailing={<FaIcon icon={faSuperscript} />}
      >
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('subscript')}
        feature={EditorFeature.subscript}
        onClick={() => editor.chain().focus().toggleSubscript().run()}
        title={'Sub script'}
        trailing={<FaIcon icon={faSubscript} />}
      >
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('nobreak')}
        feature={EditorFeature.nobreak}
        onClick={() => editor.chain().focus().toggleMark('nobreak').run()}
        title={'No break'}
      >
        <span className={'underline decoration-slate-400 decoration-double'}>
          no break
        </span>
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('medium')}
        feature={EditorFeature.medium}
        onClick={() => editor.chain().focus().toggleMedium().run()}
        title={'Medium'}
      >
        medium
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('finePrint')}
        feature={EditorFeature.fineprint}
        onClick={() => editor.chain().focus().toggleFinePrint().run()}
        title={'Fineprint'}
      >
        fine
      </EditorControlButton>
      <EditorControlButton
        active={editor.isActive('small')}
        feature={EditorFeature.small}
        onClick={() => editor.chain().focus().toggleSmall().run()}
        title={'Small'}
      >
        small
      </EditorControlButton>
    </ControlGroup>
  )
}
